import { Fragment } from 'react';
import { Checkbox } from '@upmc/ims.component-library';

import Icon from '../../../components/UI/MDC/Icon/Icon';
import { Headline6 } from '../../../components/UI/MDC/Typography/Typography';
import classes from '../../../components/UI/Input/RadioButton/RadioButton.module.scss';
import classes2 from '../UserAccessReview.module.scss';
import Card from '../../../components/UI/MDC/Card/Card';
import StyleAuxiliary from '../../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import classnames from 'classnames';

const ValidationCheckboxList = props => {
	const { entryKey, formDetails, handleChange, onBlur, disabled } = props;
	const showValidation = formDetails.validation.touched;
	const validationMessage = showValidation ? props.validationMessage : null;
	const validity = showValidation
		? !(props.validationMessage && props.validationMessage.length > 0) &&
		  props.valid
		: true;
	const iconStyle = validity
		? 'validation__icon--valid'
		: 'validation__icon--invalid';
	const iconShape = validity ? 'check_circle_outline' : 'block';

	const combinedTextboxStyles = [];
	if (props.className) {
		combinedTextboxStyles.push(props.className);
	}
	combinedTextboxStyles.push(classes['input__textbox--partial-width']);

	return (
		<>
			<Fragment>
				<StyleAuxiliary
					classes={classnames(
						classes['input__radio--full-width'],
						classes['input__radio__container']
					)}
				>
					<Icon
						icon={iconShape}
						className={classnames(
							classes[iconStyle],
							classes2['validation-checkbox-list__icon']
						)}
					/>
					<section
						className={classnames(
							classes2['full--width'],
							classes2['user-search__container--vert']
						)}
					>
						<Card
							xlarge
							className={classes2['input__card--overflow']}
						>
							{formDetails.options.map(detail => (
								<Checkbox
									size='samll'
									key={detail.key}
									label={detail.value}
									value={detail.key}
									checked={detail.checked}
									disabled={disabled}
									onChange={() =>
										handleChange(
											{ target: { value: detail } },
											entryKey
										)
									}
									onBlur={onBlur}
								/>
							))}
						</Card>
						<StyleAuxiliary
							classes={classes['input__validation--invalid']}
						>
							<Headline6>{validationMessage}</Headline6>
						</StyleAuxiliary>
					</section>
				</StyleAuxiliary>
			</Fragment>
		</>
	);
};

export default ValidationCheckboxList;
